<template>
  <!-- <div class="change-password">
    <cg-password :config="changePasswordConfig" @register="handleChangePassword"></cg-password>
  </div> -->
  <div class="h-box">
    <h2 class="global-title">{{ $t('mbs-change-password-tit') }}</h2>
    <div class="form-box">
      <div class="login-formitem-group">
        <input
          type="text"
          id="username"
          autocomplete="off"
          style="display: block; height: 0; opacity: 0"
        />
        <div class="form-item-label">
          <label for="oldPassword">{{ $i18n.t('mbs-old-password') }}*</label>
        </div>
        <div class="new-password-input">
          <input
            class="form-item-input fs-mask"
            :type="oldPswInputType"
            id="oldPassword"
            autocomplete="off"
            role="input old password"
            v-model.trim="oldPassword"
            @input="handleOldPswChange"
          />
          <img
            v-show="showOldPsw"
            class="eye"
            src="~img/icon-feather-eye-on.svg"
            @click="() => changeOldPswType('password')"
            alt="hide old password"
          />
          <img
            v-show="!showOldPsw"
            class="eye"
            src="~img/icon-feather-eye-off.svg"
            @click="() => changeOldPswType('text')"
            alt="show old password"
          />
        </div>
      </div>
      <!-- newPassword input -->
      <div class="login-formitem-group">
        <div class="form-item-label">
          <label for="newPassword">{{ $i18n.t('mbs-new-password') }}*</label>
        </div>
        <div class="new-password-input">
          <input
            class="form-item-input fs-mask"
            :class="{ 'input-border-err': validateErr }"
            :type="newPswInputType"
            id="newPassword"
            autocomplete="new-password"
            role="input new password"
            v-model.trim="newPassword"
            @input="handleNewPswChange"
          />
          <img
            v-show="showNewPsw"
            class="eye"
            src="~img/icon-feather-eye-on.svg"
            @click="() => changeNewPswType('password')"
            alt="hide new password"
          />
          <img
            v-show="!showNewPsw"
            class="eye"
            src="~img/icon-feather-eye-off.svg"
            @click="() => changeNewPswType('text')"
            alt="show new password"
          />
        </div>
      </div>
      <div class="new-password-rules">
        <div class="desc-item" v-for="(item, index) in pswRules" :key="index">
          <img v-if="item.matched" src="~img/check-green.png" alt="psw-img" />
          <img v-if="!item.matched" src="~img/check-gray.png" alt="psw-img" />
          <p
            :class="{
              'psw-right': item.matched,
              'psw-error': !item.matched,
            }"
          >
            {{ $i18n.t(item.desc) }}
          </p>
        </div>
      </div>
      <!-- confirmPassword input -->
      <div class="login-formitem-group">
        <div class="form-item-label">
          <label for="confirmPassword">{{ $i18n.t('mbs-confirm-new-password') }}*</label>
        </div>
        <div class="confirm-password-input">
          <input
            class="form-item-input fs-mask"
            :class="{ 'input-border-err': errMsg }"
            :type="confirmPswInputType"
            id="confirmPassword"
            autocomplete="new-password"
            role="input confirm password"
            v-model="confirmPassword"
            @input="handleConfirmPswChange"
          />
          <img
            v-show="showConfirmPsw"
            class="eye"
            src="~img/icon-feather-eye-on.svg"
            @click="() => changeConfirmPswType('password')"
            alt="hide confirm password"
          />
          <img
            v-show="!showConfirmPsw"
            class="eye"
            src="~img/icon-feather-eye-off.svg"
            @click="() => changeConfirmPswType('text')"
            alt="show confirm password"
          />
        </div>
      </div>
      <!-- 错误提示 -->
      <p v-if="errMsg" class="error-message">{{ errMsg }}</p>
      <p v-if="notMatch" class="error-message">{{ $i18n.t('forgetpsw-notmatch') }}</p>
    </div>
    <div class="button">
      <div class="login-btn" :class="{ 'login-btn-disable': loginDisable }">
        <div v-if="!loading" @click="handleSave" role="button">{{ $i18n.t('btn-save') }}</div>
        <img v-else class="btn-loading" src="~img/loading.gif" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
  // import CgPassword from '@/views/SignUp/componets/Step3';
  // import { changePasswordConfig } from './changePasswordConfig';
  import { mapMutations, mapState } from 'vuex';
  const pswRules = [
    {
      matched: false,
      regExp: /^.{8,}/,
      desc: 'forgetpsw-rule1',
    },
    {
      matched: false,
      regExp: /[a-záàâäæçéèêëíîïñóôœúùûüö]/,
      desc: 'forgetpsw-rule2',
    },
    {
      matched: false,
      regExp: /[A-ZÁÀÂÄÆÇÉÈÊËÍÎÏÑÓÔŒÙÛÜÖ]/,
      desc: 'forgetpsw-rule3',
    },
    {
      matched: false,
      regExp: /\d/,
      desc: 'forgetpsw-rule4',
    },
    /* eslint-disable */
    {
      matched: false,
      /* regExp: {
        test: str => {
          const reg1 = /[!#$%&*,.:;?@\[\]^_{|}+=¡¿~]/;
          // const reg2 = /[\<\>\/'"\-\\\(\)]/;
          const reg2 = /[^a-záàâäæçéèêëíîïñóôœúùûüöA-ZÁÀÂÄÆÇÉÈÊËÍÎÏÑÓÔŒÙÛÜÖ\d!#$%&*,.:;?@\[\]^_{|}+=¡¿~]/g;
          return reg1.test(str) && !reg2.test(str);
        },
      }, */
      regExp: /[!#$%&*,.:;?@[\]^_{|}+=¡¿~<>\/'"\-\\()«»¢£¤¥§©¬®¯°±²³´`µ¶·¸¹º¼½¾×÷]/,
      desc: 'forgetpsw-rule5',
    },
  ];
  export default {
    name: 'ChangePassword',

    // components: {
    //   CgPassword,
    // },

    data() {
      return {
        // changePasswordConfig,
        validateErr: false,
        loginDisable: true,
        oldPswInputType: 'password',
        newPswInputType: 'password',
        confirmPswInputType: 'password',
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
        pswRules,
        notMatch: false,
        showSuccessInfo: true,
        errMsg: '',
        loading: false,
      };
    },

    computed: {
      showOldPsw() {
        return this.oldPswInputType === 'text';
      },
      showNewPsw() {
        return this.newPswInputType === 'text';
      },
      showConfirmPsw() {
        return this.confirmPswInputType === 'text';
      },
      ...mapState(['userInfo']),
    },

    methods: {
      ...mapMutations(['showMessageModal']),
      jumpRouter() {
        this.$router.push('/account/membership');
      },
      handleChangePassword(value) {
        const { userId, sessionId } = this.userInfo;
        const { oldPassword, confirmPassword } = value;
        const data = {
          userId,
          newPassword: confirmPassword,
          sessionId,
          oldPassword,
        };
        this.$http.member
          .changePassword(data)
          .then(res => {
            if (res.state === '11') {
              this.$messageModal.show({
                i18nNeed: true,
                image: true,
                title: 'msg-success-status',
                desc: 'msg-success',
                confirmBtn: 'btn-ok',
                justHide: true,
                callback: this.jumpRouter,
              });
            } else {
              res.note && this.showMessageModal({ key: res.note, i18nNeed: false });
            }
          })
          .catch(err => {});
      },
      showSuccess(cb) {
        this.showSuccessInfo = true;
        setTimeout(() => {
          cb && cb();
        }, 2000);
      },
      changeOldPswType(value) {
        this.oldPswInputType = value;
      },
      changeNewPswType(value) {
        this.newPswInputType = value;
      },
      changeConfirmPswType(value) {
        this.confirmPswInputType = value;
      },
      handleOldPswChange(e) {
        const { value } = e.target;
        let flag = !value;

        if (!this.newPassword) {
          flag = true;
        }
        if (!this.confirmPassword) {
          flag = true;
        }
        this.pswRules.forEach(item => {
          if (!item.regExp.test(this.newPassword)) {
            flag = true;
          }
        });
        this.loginDisable = flag;
      },
      handleNewPswChange(e) {
        const { value } = e.target;
        // 校验
        let buttonFlag = false;
        let validateFlag = false;
        this.pswRules.forEach(item => {
          if (item.regExp.test(value)) {
            item.matched = true;
          } else {
            item.matched = false;
            validateFlag = true;
            buttonFlag = true;
          }
        });
        // 如果没有填写旧密码也要保持禁用状态
        if (!this.oldPassword) {
          buttonFlag = true;
        }
        if (!this.confirmPassword) {
          buttonFlag = true;
        }
        this.loginDisable = buttonFlag;
        this.validateErr = validateFlag;
      },
      handleConfirmPswChange(e) {
        this.notMatch = false;
        const { value } = e.target;
        let flag = !value;
        if (!this.oldPassword) {
          flag = true;
        }
        if (!this.newPassword) {
          flag = true;
        }
        this.pswRules.forEach(item => {
          if (!item.regExp.test(this.newPassword)) {
            flag = true;
          }
        });
        this.loginDisable = flag;
      },
      handleSave() {
        if (this.loginDisable) return;
        if (this.newPassword === this.confirmPassword) {
          const payload = {
            oldPassword: this.oldPassword,
            confirmPassword: this.confirmPassword,
          };
          this.handleChangePassword(payload);
        } else {
          this.notMatch = true;
        }
      },
    },
  };
</script>

<style scoped lang="scss">
@use './index.scss';
</style>
